import React from 'react';
import { Col, Divider, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { SupplierBankInformation } from './bankInformation';
import { SupplierPricingRules } from './pricingRules';
import styles from './styles.module.scss';
import { SupplierLegal } from './legal';
import { SupplierSpecialPricingRules } from 'feature/supplierTabs/pricing/specialPricingRules';

export const SupplierPricing = React.memo(() => {
  return (
    <Col span={24}>
      <Row className={'gap-32'}>
        <Col flex={'1'}>
          <Row gutter={[0, 32]}>
            <Col span={24}>
              <HasAccess role={PERMISSIONS.suppliers.pricing_rules.read}>
                <SupplierPricingRules />
              </HasAccess>
            </Col>
            <Col span={24}>
              <HasAccess role={PERMISSIONS.suppliers.legal.read}>
                <SupplierLegal />
              </HasAccess>
            </Col>
            <Col span={24}>
              <HasAccess role={PERMISSIONS.suppliers.bank_information.read}>
                <SupplierBankInformation />
              </HasAccess>
            </Col>
          </Row>
        </Col>
        <Divider type={'vertical'} className={styles.divider} />
        <Col flex={'1'}>
          <HasAccess role={PERMISSIONS.suppliers.special_pricing_rules.read}>
            <SupplierSpecialPricingRules />
          </HasAccess>
        </Col>
      </Row>
    </Col>
  );
});
